module.exports = __webpack_public_path__ + "static/media/nat.b0e770bf.jpg";